import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const healthDataForm: Form<Client> = {
  key: 'healthData',
  title: 'Gesundheit',
  fields: [
    {
      key: 'healthInsurance',
      label: 'Krankenkasse',
      fieldTypes: 'text',
    },
    {
      key: 'healthInsuranceNumber',
      label: 'Versichertennummer',
      fieldTypes: 'text',
    },
    {
      key: 'familyDoctor',
      label: 'Hausärzt*in',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'disease',
      label: 'Erkrankungen',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'allergy',
      label: 'Allergien',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'medicine',
      label: 'Medikamente',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'pregnancy',
      label: 'Schwangerschaft',
      fieldTypes: 'checkbox',
    },
    {
      key: 'pregnancyCalculatedDate',
      label: 'errechneter Geburtstermin',
      fieldTypes: 'date',
      isVisible: (client) => client.pregnancy === true,
    },
    {
      key: 'healthNotice',
      label: 'Notiz',
      xsWidth: 12,
      fieldTypes: 'textArea',
    },
  ],
};

export default healthDataForm;
